import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { CloudOff } from 'lucide-react';
import { useAuth } from '../../Authentication/components/RealTimeAuthStatus';
import LoginModal from './LoginModal';

const SignInPill: React.FC = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { session } = useAuth();
  const isAuthenticated = !!session;
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  // Check online status
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Always show the pill when user is not authenticated and online
  if (!isOnline || isAuthenticated) {
    return null;
  }

  return (
    <>
      <motion.button
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={() => setShowLoginModal(true)}
        className="flex items-center px-2 sm:px-3 py-0.5 sm:py-1.5 backdrop-blur-lg rounded-full shadow-md border bg-white/80 border-sky-200/50 hover:bg-white/90 transition-colors cursor-pointer"
      >
        {/* Pulsing dot - no animation on mobile */}
        <motion.div
          animate={{ 
            scale: [1, 1.2, 1],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          className="relative mr-1 sm:mr-2"
        >
          <div className="w-1.5 sm:w-2 h-1.5 sm:h-2 rounded-full bg-sky-500" />
          <div className="absolute inset-0 w-1.5 sm:w-2 h-1.5 sm:h-2 rounded-full animate-ping bg-sky-400 hidden sm:block" />
        </motion.div>

        <CloudOff className="w-3 sm:w-4 h-3 sm:h-4 text-sky-600 mr-1 sm:mr-1.5" strokeWidth={2} />
        <span className="text-[10px] sm:text-xs font-medium text-sky-700 mr-1.5 sm:mr-2">Local Storage</span>
        <span className="text-[10px] sm:text-xs bg-sky-600 text-white px-1.5 sm:px-2 py-0.5 rounded-full font-medium">
          Sign In
        </span>
      </motion.button>

      <LoginModal 
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />
    </>
  );
};

export default SignInPill;